module.exports = __webpack_public_path__ + "images/buttons/our_blog-gray.gif";